"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    return {
        schemaType: "object",
        properties: [
            {
                propertyName: "rawFiles",
                title: "",
                stacked: true,
                schema: {
                    schemaType: "array",
                    readOnly: true,
                    item: {
                        schemaType: "object",
                        properties: [
                            {
                                title: "翻訳ファイル名",
                                propertyName: "fileName",
                                schema: {
                                    schemaType: "text",
                                },
                            },
                            {
                                title: "プレビュー",
                                propertyName: "records",
                                schema: {
                                    schemaType: "table",
                                    readOnly: true,
                                    pageSize: 5,
                                },
                            },
                        ],
                    },
                },
            },
        ],
    };
};
